import React, { Component } from "react";
import { GoogleMap, GoogleMapProps, withGoogleMap, withScriptjs } from "react-google-maps";

export interface Props extends GoogleMapProps {

}

class Map extends Component<Props> {
	static defaultProps: Partial<Props> = {
		zoom: 11,
		center: {
			lat: 25.1883794,
			lng: 55.3012818,
		},
	};

	render() {
		const props = this.props;
		return <GoogleMap { ...props }>
			{ props.children }
		</GoogleMap>;
	}
}

export default withScriptjs( withGoogleMap( Map ) );
